<template>
  <div class="hoverDialog">
    <div class="jBtn">
      <div class="jBtn1" v-if="isSearch == 0">
        <div
          class="attention"
          v-if="!item.isFocus"
          @click.stop="clickAttention(item, true)"
        >
          <img src="@/assets/hideBox/guanzhu.png" alt />
          <span>关注</span>
        </div>
        <div class="attention" v-else @click.stop="clickAttention(item, false)">
          <img src="@/assets/hideBox/yiguanzhu.png" alt />
          <span>已关注</span>
        </div>
      </div>
      <div class="jBtn1" v-if="isSearch == 1">
        <div
          class="attention"
          v-if="!item.is_focus"
          @click.stop="clickAttention(item, true)"
        >
          <img src="@/assets/noguanzhupic.png" alt />
          <span>关注</span>
        </div>
        <div class="attention" v-else @click.stop="clickAttention(item, false)">
          <img src="@/assets/guanzhupic.png" alt />
          <span>已关注</span>
        </div>
      </div>
      <div class="jBtn1" @click.stop="inByLetDialogClick(item)">
        <img src="@/assets/hideBox/hanxun.png" alt />
        <span>函询</span>
      </div>
      <div class="jBtn1" @click.stop="toChat(item)">
        <img src="@/assets/hideBox/jiaoliu.png" alt />
        <span>交流</span>
      </div>
      <div class="jBtn2" @click.stop="signUp(item)" v-if="type == 4">
        <img src="@/assets/hideBox/baoming.png" alt />
        <span>立即报名</span>
      </div>
      <div class="jBtn2" @click.stop="mysignUp(item)" v-else-if="type == 7">
        <img src="@/assets/hideBox/baoming.png" alt />
        <span>我要报名</span>
      </div>
      <div class="jBtn2" v-else>
        <img src="@/assets/hideBox/detail.png" alt />
        <span>查看详情</span>
      </div>
    </div>
    <el-dialog
      title="请确认报名信息"
      v-if="sendtype"
      :visible.sync="sendtype"
      :append-to-body="true"
      width="400px">
      <div>
        <el-row style="padding-left: 20px">
          <el-col :span="24" style="margin-bottom: 30px">工种：{{Detail.workName}}</el-col>
          <el-col :span="12">姓名：{{info.userName}}</el-col>
          <el-col :span="12">联系电话：{{info.userPhone}}</el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="sendtype = false">取 消</el-button>
        <el-button type="primary" @click="send">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { apiResignAll } from "@/api/apiResignAll"
import apiHelp from "@/api/apiHelp"
import eventBus from "@/utils/event-bus"
import axios from "@/http"
import { mapState } from "vuex"
import {apiFlexibleEmployment} from "@/api/apiFlexibleEmployment"
export default {
  name: "hideBox",
  components: {},
  props: {
    item: {
      type: Object
    },
    type: {
      type: Number // 1 工队 2 工程 3 工人 4 临时用工 5 工种报价 6劳务用工
    },
    jIndex: {
      type: Number
    },
    isSearch: {
      type: Number,
      default: 0 // 0 其他列表页 1 搜索页
    }
  },
  data() {
    return {
      isAttention: false,
      isRepeatSubmit: false,
      sendtype:false,
      info:{},
      Detail:{},
    }
  },
  filters: {},
  watch: {},
  computed: {
    ...mapState({
      userNo: state => state.user.no,
      companyNo: state => state.user.companyNo
    })
  },
  methods: {
    /**
     * @name 关注
     * @type 1 工队 2 工程 3 工人 4 临时用工 5 工种报价 6劳务用工
     **/
    clickAttention(item, state) {
      let token = this.$store.state.token
      if (!token) {
        let data = {
          callBack: function() {
            this.$store.dispatch("setUser")
          }.bind(this)
        }
        this.$_login(data)
      } else {
        // let type;
        // type= this.type
        this.isAttention = state
        if (this.isRepeatSubmit) return
        this.isRepeatSubmit = true
        if(this.type==2){
          apiHelp.attentionHandle({
            businessNo: item.companyNo,
            type: 0
          }).then(v=>{
            if(v.data.code==200){
              this.$toast(state?'关注成功':'取消关注成功', 'success')
              item.isFocus=state;
            }else{
              this.$toast(res.data.msg, 'error')
            }
          })
          return;
        }
        apiResignAll
          .addAttention(item.no, this.type, this.isAttention)
          .then(res => {
            if (res.data.code === 200 && res.data.data !== "不能关注自己发布的信息") {
              this.$toast(res.data.data, res.data.data=='关注成功'?'success':'cancel')
              if (this.isSearch === 0) {
                item.isFocus = !item.isFocus
              } else {
                item.is_focus = !item.is_focus
              }
              this.userFocus(item.no)
            } else {
              if(res.data.data) this.$toast(res.data.data, 'error')
              else if(res.data.msg)this.$toast(res.data.msg, 'error')
            }
          })
          .finally(() => {
            this.isRepeatSubmit = false
          })
      }
    },
    /** @name 获取是否关注 */
    userFocus(no) {
      let type
      if (this.type === 4) {
        type = 4
      } else {
        type = 5
      }
      apiResignAll.userFocus(no, type).then(res => {
        if (res.data.code === 200) {
          this.isAttention = res.data.data
        }
      })
    },
    loginIndex() {
      let data = {
        callBack: function() {
          this.$store.dispatch("setUser")
          //this.pushThis()
        }.bind(this)
      }
      this.$_login(data)
    },
    /** @name 函询 */
    inByLetDialogClick(item) {
      if (this.$store.state.loginType) {
        if (item.userNo === this.userNo || item.user_no === this.userNo) {
          this.$message.error("不能给自己发送函询！")
          return
        }
        // if (item.companyNo === this.companyNo) {
        //   this.$message.error("不能给自己发送函询！")
        //   return
        // }
        this.$emit("inByLetDialogClick", item)
      } else {
        this.loginIndex()
      }
    },
    // 交流
    toChat(item) {
      if (this.$store.state.loginType) {
        if (item.userNo === this.userNo || item.user_no === this.userNo) {
          this.$message.error("不能和自己交流！")
          return
        }
        if (item.companyNo === this.companyNo) {
          this.$message.error("不能和自己交流！")
          return
        }
        if (item.imId) {
          axios
            .get(
              process.env.VUE_APP_COMPANY +
                "/v1/organization/getUser/" +
                item.imId
            )
            .then(res => {
              if (res.data.code === 200) {
                if (res.data.data.imAccount) {
                  eventBus.$emit("sendImMessage", res.data.data.imAccount)
                } else {
                  this.$message.err("未找到客服人员")
                }
              } else {
                this.$message.error(res.data.msg)
              }
            })

        } else {
          if(item.employmentType==1)this.$message.error("未设置客服人员，无法交流！")
          else this.$message.error("该信息为个人用户发布，当前无法交流")
        }
      } else {
        this.loginIndex()
      }
    },
    /** @name 跳转立即报名 */
    signUp(item) {
      let user=this.$store.state.user;
      if(!user.imAccount){
        let data = {
          callBack: function() {
            this.$store.dispatch("setUser")
          }.bind(this)
        }
        this.$_login(data);
        return;
      }
      let state='';
      if(user.type===0){
        state=user.no==item.userNo?"自己不能报名自己发布的临时用工":''
      }else if(user.type===1){
        state=user.companyNo==item.companyNo?"自己不能报名自己发布的临时用工":''
      }else if(user.type===2){
        state=user.teamNo==item.teamNo?"自己不能报名自己发布的临时用工":''
      }
      if(item.isApply){
        state="请勿重复报名"
      }
      if(state){
        this.$message.error(state)
        return;
      }
      this.$router.push({
        path: "/signUp",
        query: {
          no: item.no,
          categoryNo: item.categoryNo || item.category_no,
          industryNo: item.industryNo || item.industry_no,
          categoryName: item.categoryName || item.category_name,
          industryName: item.industryName || item.industry_name
        }
      })
    },
    //我要报名
    async mysignUp(item){
      if (!this.$store.state.loginType) {
        this.loginIndex();
        return;
      }
      this.Detail=item
      let res = await apiResignAll.getIsEnable(item.no)
      if(res.data.code==200&&res.data.data.isEnable){
        let userAuthority = this.$store.state.authUser.authority

        // 判断当前用户身份是否为“企业/团队”
        /*  if(userAuthority.includes('ROLE_company')){
             return this.$message({ message:'请前往用户中心将身份切换为个人才可报名', type: "error" })
         } */

        if(userAuthority.includes('ROLE_member') && userAuthority.length>1){
          return this.$message({ message:'请前往用户中心将身份切换为个人才可报名', type: "error" })
        }

        let user=this.$store.state.user;
        if(!user.imAccount){
          let data = {
            callBack: function() {
              this.$store.dispatch("setUser")
            }.bind(this)
          }
          this.$_login(data);
          return;
        }
        let state='';
        if(user.type==0){
          state=user.no==this.Detail.userNo?"自己不能报名自己发布的劳务用工":''
        }else if(user.type==1){
          state=user.companyNo==this.Detail.companyNo?"自己不能报名自己发布的劳务用工":''
        }else if(user.type==2){
          state=user.teamNo==this.Detail.teamNo?"自己不能报名自己发布的劳务用工":''
        }

        if(state){
          this.$message.error(state)
          return;
        }
        let res=await apiFlexibleEmployment.laborEmploymentIsApply(this.Detail.no)
        if(res.data.code!=200){
          if(res.data.code==201){
            this.$confirm('劳务用工报名需要实名认证，是否前往实名认证？', '温馨提示', {
              confirmButtonText: '前往认证',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              window.open(`${process.env.VUE_APP_PERSONURL}/authenticationRealName`)
            })
          }else {
            if(res.data.code==202){
              return this.$message.error(res.data.msg)
            }
            this.$message.error(res.data.msg)
          }
          return;
        }
        this.info=res.data.data;
        this.sendtype=true;
      }else{
        this.$message.warning('该劳务用工已招满，请重新选择')
        this.$emit('getlist');
      }
    },
    //我要报名-确认报名
    send(){
      apiFlexibleEmployment.laborEmploymentApply({
        relationNo:this.Detail.no,
        workNo:this.Detail.workNo
      }).then(res=>{
        if(res.data.code==200){
          this.$message.success('报名成功')
        }else{
          this.$message.error(res.data.msg)
        }
      }).finally(v=>{
        this.sendtype=false;
      })
    }
  },
  created() {},
  mounted() {}
}
</script>

<style lang="scss" scoped>
.hoverDialog {
  position: absolute;
  width: 100%;
}
.jBtn {
  width: 100%;
  position: relative;
  left: -1px;
  top: 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  overflow: hidden;
  cursor: pointer;
  border: 1px solid #b79255;
  border-top: none;
  // border-right: none;
  .jBtn1 {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30%;
    height: 40px;
    line-height: 40px;
    // color: #666666;
    color: #ffffff;
    background: #b79255;
    margin-right: 1px;
    .attention {
      display: flex;
      align-items: center;
      width: 100%;
      justify-content: center;
    }
    img {
      margin-right: 4px;
    }
  }
  .jBtn2 {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30%;
    height: 40px;
    line-height: 40px;
    color: #ffffff;
    background: #b79255;
    img {
      margin-right: 4px;
    }
  }
  .jBtn3 {
    width: 20%;
    height: 40px;
    text-align: center;
    line-height: 40px;
    // color: #666666;
    color: #ffffff;
    background: #b79255;
    margin-right: 1px;
  }
  .jBtn4 {
    width: 20%;
    height: 40px;
    text-align: center;
    line-height: 40px;
    // color: #666666;
    color: #ffffff;
    background: #b79255;
    margin-right: 1px;
  }
}
.jBtn5 {
  width: 100%;
  position: relative;
  left: -1px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  overflow: hidden;
  cursor: pointer;
  border: 1px solid #e4e7ed;
  border-top: none;
  background: #b79255;
  color: #ffffff;
  .jBtn6 {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 30%;
    height: 40px;
    line-height: 40px;
    // color: #666666;
    color: #ffffff;
    img {
      width: 16px;
      height: 16px;
      margin-right: 10px;
    }
  }
}
</style>
